import { createSelector } from 'reselect'

export function currentEvent(state) { return state.events ? state.events.event : null}
// export function eventClassesForCurrentEvent(state) { return state.events && state.events.event ? state.events.event.eventClasses : null}
export function currentTrackID(state) { return state.events.currTrackID}
export function currentCheckpointID(state) { return state.events.currCheckPointID}
export function currentEventClassID(state) { return state.events.currEventClassID}


export const currentTrack = createSelector(
  currentEvent
  , currentTrackID
  , ( e, tId)  => {
    return (e && tId && e.tracks
        ? e.tracks.find( (t) => t.id === tId)
        : null
        )
      }
)

export const currentCheckpoint = createSelector(
  currentTrack
  , currentCheckpointID
  , ( cT, cCId)  => {
    const trackVariant = cT && cT.trackVariants ? cT.trackVariants[0] : null

    return (trackVariant && trackVariant.controls && cCId > -1
    ? trackVariant.controls.find( (c) => c.sequence === cCId)
    : null)
  }
)

export const currentEventClass = createSelector(
  currentEvent
  , currentEventClassID
  , ( e, ecId)  =>
    e && e.eventClasses && ecId
        ? e.eventClasses.find( (ec) => ec.id === ecId)
        : null
)

export const eventClassesForTrack = (track, eventClasses) => {
  return eventClasses.filter( (ec) => track.eventClasses?.indexOf(ec.id) > -1 )
} 

 export const eventClassesForCurrentTrack = createSelector(
  currentEvent
  , currentTrack
   , ( e, t)  => {
    return (
      t 
      ? eventClassesForTrack(t, e.eventClasses) 
      : null
    )}
 )

//  export const eventClassesForCurrentTrack = createSelector(
//    eventClassesForCurrentEvent
//    , currentTrack
//    , ( eCs, t)  =>
//      eCs
//          ? t.eventClasses
//          : null
//  )

const sortCompetitors = (event, list) => {
//  const typeOfResult = "ABSOLUTE"
  const typeOfResult = event.resultConfig.resultList
  return list.sort( (a,b) => {

    if(typeOfResult === "ABSOLUTERANK") {
      if( a.finishTime !== undefined && b.finishTime === undefined) {
        return -1
      }
      else if( a.finishTime === undefined  && b.finishTime  !== undefined ) {
        return 1
      }
      // else if( timeAsInt( a.finishTime) > timeAsInt( b.finishTime)) {
        else if( a.finishTime > b.finishTime) {
          // console.log( a.finishTime + " " + b.finishTime)
          return 1
        }
        else {
          return -1
        }
    }
    else {
      if( a.raceTime !== undefined && b.raceTime === undefined) {
        return -1
      }
      else if( a.raceTime === undefined  && b.raceTime  !== undefined ) {
        return 1
      }
      // else if( timeAsInt( a.finishTime) > timeAsInt( b.finishTime)) {
        else if( a.raceTime > b.raceTime) {
          // console.log( a.finishTime + " " + b.finishTime)
          return 1
        }
        else {
          return -1
        }
      }
    }
  )
  .map( (c, i) => {
    c.rankNo = c.finishTime && c.status !== 'DSQ' ? i+1 : null
    c.finalSortNo = c.finishTime && c.status !== 'DSQ' ? i+1 : 99999
    return c
  })

}
export const competitorsForCurrentTrack = createSelector(
  currentEvent
  , eventClassesForCurrentTrack
    , ( event, eCs) => {

      let sortedComp
      if( eCs ) {
        sortedComp = eCs.map( (ec) => ec.competitors ? ec.competitors : [])?.flat() 
        sortedComp = sortCompetitors( event, sortedComp)

      }
      else {
        sortedComp = null
      }
      return ( 
        sortedComp
      )
  }
)

// export const checkPointsForCurrentTrack = createSelector(
//     currentTrack
//     , ( t) => 
//     t 
//     ? t.controls 
//     : null
// )

export const competitorsForCurrentSelection = createSelector(
  currentEvent
  ,   competitorsForCurrentTrack
    , currentEventClass
    , ( event, ccT, cEC) => 
        cEC && cEC.competitors.length > 0
        ? sortCompetitors( event, cEC.competitors)
        : ccT
)

export const competitorsAtCurrentCheckpoint = createSelector(
  currentEvent
    , competitorsForCurrentSelection
    , currentCheckpoint
    , currentEventClass
    , (event, cCs, cCp, cEc) => {
        let sortedComp
        if( cCs && cCs && cCp) {
          sortedComp = cCs.map( (c) => setTimesAndRankAtCheckpoint(c, cCp.sequence))
          
          sortedComp = sortCompetitors( event, sortedComp)
        }
        else {
          sortedComp = null
        }
        // console.log(cCs)
        // console.log(cCp)
        // console.log(cEc)
        // console.log(sortedComp)
        return ( 
          sortedComp
        )
    }
  )


const setTimesAndRank = ( comp, visitedAt, timeAt, rankAt, timeBehind) => {
  comp.raceTime = timeAt
  comp.finishTime = visitedAt
  comp.rankNo = rankAt
  comp.finalSortNo = rankAt ? rankAt : 99999
  comp.timeToLeader = timeBehind

  return comp
}

const setTimesAndRankAtCheckpoint = ( comp, sequence) => {
  let compClone = JSON.parse(JSON.stringify(comp))
  compClone = setTimesAndRank( compClone, undefined, undefined, undefined)
  const cpV = comp.controlVisits ? comp.controlVisits.find( (cv) => cv.checkpointControl.sequence === sequence) : null
  if( cpV) {
    compClone = setTimesAndRank( compClone, cpV.visitedAt, cpV.timeAt, cpV.timeRank, cpV.timeBehind)
  } 
  return compClone 
}
